import { Formik } from "formik";
import PlusIcon from "./icon/PlusIcon";
import LinkButton from "./controls/LinkButton";
import Col from "./layout/Col";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import TypeaheadField from "./controls/TypeaheadField";
import { filtrarCaracteristicasPeligrosidad } from "../utils/data";
import Label from "./controls/Label";
import TrashIcon from "./icon/TrashIcon";
import { isInvalid } from "../utils/forms";
import { useTranslation } from "react-i18next";

export function CaracteristicaPeligrosidadForm({
  value,
  append,
  remove,
  caracteristicasPeligrosidad,
  disabled,
}) {
  const { t } = useTranslation();
  const handlePeligrosidadChange = (form) => (event) => {
    form.handleChange(event);
  };
  const validateCaraceristicaPeligrosidad = (values) => {
    const errors = {};
    if (
      !values.caracteristicaPeligrosidad ||
      Object.keys(values).length === 0
    ) {
      errors.caracteristicaPeligrosidad =
        "errors.residuoPeligroso.peligrosidad.caracteristicaPeligrosidad.required";
    }
    return errors;
  };
  const handleSubmit = (values, { resetForm }) => {
    append(values.caracteristicaPeligrosidad);
    resetForm({ values: { caracteristicaPeligrosidad: null } });
  };
  return (
    <ListGroup>
      {value.map((caracteristica, index) => (
        <ListGroupItem>
          <Grid>
            <Row style={{ display: "flex", flexWrap: "wrap" }}>
              <Col lg={11}>
                <Label>{`(${caracteristica?.codigo}) ${caracteristica?.nombre}`}</Label>
              </Col>
              <Col lg={1}>
                <LinkButton
                  sm
                  style={{ margin: "25%", fontSize: "16px" }}
                  onClick={(event) => {
                    event.preventDefault();
                    remove(index);
                  }}
                  disabled={disabled}
                >
                  <TrashIcon />
                </LinkButton>
              </Col>
            </Row>
          </Grid>
        </ListGroupItem>
      ))}
      <ListGroupItem>
        <Formik
          initialValues={{ caracteristicaPeligrosidad: null }}
          validateOnChange={true}
          validate={validateCaraceristicaPeligrosidad}
          onSubmit={handleSubmit}
        >
          {(form) => (
            <Grid>
              <Row style={{ display: "flex", flexWrap: "wrap" }}>
                <Col lg={11}>
                  <TypeaheadField
                    id="residuoPeligroso_peligrosidad_caracteristicaPeligrosidad"
                    name="caracteristicaPeligrosidad"
                    style={{
                      margin: 0,
                    }}
                    value={form.values.caracteristicaPeligrosidad}
                    onChange={handlePeligrosidadChange(form)}
                    options={filtrarCaracteristicasPeligrosidad(
                      caracteristicasPeligrosidad,
                      value,
                    )}
                    labelAttr={(value) => `(${value.codigo}) ${value.nombre}`}
                    valueAttr="codigo"
                    emptyLabel="..."
                    isInvalid={isInvalid("caracteristicaPeligrosidad", form)}
                    error={t(form.errors.caracteristicaPeligrosidad)}
                    disabled={disabled}
                  />
                </Col>
                <Col lg={1}>
                  <LinkButton
                    sm
                    style={{ margin: "25%s", fontSize: "16px" }}
                    onClick={(event) => {
                      event.preventDefault();
                      form.submitForm();
                    }}
                    disabeld={disabled}
                  >
                    <PlusIcon />
                  </LinkButton>
                </Col>
              </Row>
            </Grid>
          )}
        </Formik>
      </ListGroupItem>
    </ListGroup>
  );
}
